/* eslint-disable no-undef */
// userSaga.js
import { call,  put,  takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { PASSPORT_FILE_OPEN, PASSPORT_REQUEST, SELECTED_HEALTH_REC_ID, SELECTED_PRESCRIPTION_ID } from './Constants';
import { passportRequestError, passportRequestSuccess, selectedHealthRecIdRequestError, selectedHealthRecIdRequestSuccess, selectedPrescriptionIdRequestError, selectedPrescriptionIdRequestSuccess } from './Actions';
// import { Modal } from 'antd';


function* passportGet() {

    try {    
        
        const patientId = localStorage.getItem('PARENT_PATIENT_ID');
        const url = `${process.env.REACT_APP_API_BASE_URL}/passport/date/all?patientsId=${patientId}`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        // // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)
  

        const response = yield call(axios.get, url,{ headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            
            // Dispatch the success action with data and message      
            yield put(passportRequestSuccess(response.data));
        } else {
            // Dispatch the failure action with the response message
            yield put(passportRequestError('An error occurred.'));
        }

    } catch (error) {
        
        yield put(passportRequestError('An error occurred.'));
        // throw error;
    // yield put(fetchUserFailure(error));
    }
}



function* priscriptionGet(action) {

    try {    
        
        const Id = action.prescriptionId ;
        const url = `${process.env.REACT_APP_API_BASE_URL}/prescription?id=${Id}`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
    
        const response = yield call(axios.get, url,{ headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            yield put(selectedPrescriptionIdRequestSuccess(response.data));
        } else {
            yield put(selectedPrescriptionIdRequestError('An error occurred.'));
        }

    } catch (error) {    
        yield put(selectedPrescriptionIdRequestError('An error occurred.'));
    }
}


function* openFile(action) {

    try {    
        
        const url = action.url;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        const response = yield call(axios.get, url,{ headers, responseType: 'blob'});
        if (response.status === 200 || response.status === 201) {            
            const blob = URL.createObjectURL(response.data);
            window.open(blob);  
            // yield put(healthRecordImageRequestSuccess(response.data));
        } 

    } catch (error) {
        console.log('error', error);
        
        // yield put(healthRecordImageRequestError('An error occurred.'));
    }

}


function* healthRecGet(action) {

    try {    
        
        const Id = action.healthRecId ;
        const url = `${process.env.REACT_APP_API_BASE_URL}/healthrecords/${Id}`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
    
        const response = yield call(axios.get, url,{ headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            yield put(selectedHealthRecIdRequestSuccess(response.data));
        } else {
            yield put(selectedHealthRecIdRequestError('An error occurred.'));
        }

    } catch (error) {    
        yield put(selectedHealthRecIdRequestError('An error occurred.'));
    }
}

// Watcher Saga
export function* watchFetchPassport() {
    yield takeEvery(PASSPORT_REQUEST, passportGet);
    yield takeEvery(SELECTED_PRESCRIPTION_ID, priscriptionGet);
    yield takeEvery(PASSPORT_FILE_OPEN, openFile);
    yield takeEvery(SELECTED_HEALTH_REC_ID, healthRecGet);

}
